import React from "react";
import { motion } from "framer-motion";
import { techStack } from "../mock";

export default function TechStack() {
  const row1 = techStack.slice(0, 10);
  const row2 = techStack.slice(10);
  return (
    <section className="relative py-14 lg:py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.7 }} className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-[#73100D]/25 bg-[#73100D]/5 text-[#73100D] text-[11px] font-semibold tracking-[0.18em] uppercase mb-5">
            Technology Stack
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#111]">
            Built on{" "}
            <span className="brand-gradient-text">enterprise-grade foundations</span>
          </h2>
          <p className="mt-4 text-[#555] max-w-xl mx-auto">
            From AI frameworks to cloud-native infrastructure &mdash; we leverage the best tools to ship resilient products.
          </p>
        </motion.div>

        <div className="space-y-6">
          <Marquee items={[...row1, ...row1]} duration="40s" />
          <Marquee items={[...row2, ...row2]} duration="55s" reverse />
        </div>
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-white to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-white to-transparent" />
    </section>
  );
}

function Marquee({ items, duration = "40s", reverse = false }) {
  return (
    <div className="relative overflow-hidden">
      <div className="flex gap-5 w-max"
        style={{ animation: `marquee ${duration} linear infinite`, animationDirection: reverse ? "reverse" : "normal" }}>
        {items.map((t, i) => (
          <div key={`${t.name}-${i}`}
            className="shrink-0 group relative w-28 h-28 rounded-2xl border border-[#E5E5E5] bg-white grid place-items-center hover:border-[#73100D]/30 hover:shadow-[0_18px_40px_-18px_rgba(115,16,13,0.18)] hover:-translate-y-1 transition-all duration-300 overflow-hidden"
            title={t.name}>
            {/* Hover overlay with label */}
            <div className="absolute inset-0 bg-gradient-to-t from-[#73100D] to-[#73100D]/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
            <img src={t.logo} alt={t.name}
              className="w-12 h-12 object-contain transition-transform duration-500 group-hover:scale-110 group-hover:-translate-y-3"
              loading="lazy"
              onError={(e) => { e.currentTarget.style.display = "none"; }} />
            <div className="absolute bottom-2 left-0 right-0 text-center text-[10px] font-mono font-semibold text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              {t.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
